var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferralGlyphIcon = function SvgReferralGlyphIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.127 8.62c.404.21.56.708.348 1.111L7.2 14.083a.824.824 0 0 1-1.46-.764l2.276-4.351a.824.824 0 0 1 1.112-.349M12.884 8.631a.824.824 0 0 0-.348 1.112l2.337 4.467a.824.824 0 0 0 1.46-.764l-2.337-4.467a.824.824 0 0 0-1.112-.348",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7.599 0a3.099 3.099 0 1 0 6.198 0 3.099 3.099 0 0 0-6.198 0M22 17.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7.599 0a3.099 3.099 0 1 0 6.198 0 3.099 3.099 0 0 0-6.198 0M16 5A5 5 0 1 1 6 5a5 5 0 0 1 10 0M7.557 5a3.443 3.443 0 1 0 6.886 0 3.443 3.443 0 0 0-6.886 0"
  })));
};
export default SvgReferralGlyphIcon;